/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpSharedIconBubbleEmail_item$ref = any;
type PdpSharedIconBubbleFacebook_item$ref = any;
type PdpSharedIconBubblePinterest_item$ref = any;
export type PdpRespIconBubbles_item$ref = any;
export type PdpRespIconBubbles_item = {
    readonly " $fragmentRefs": PdpSharedIconBubblePinterest_item$ref & PdpSharedIconBubbleFacebook_item$ref & PdpSharedIconBubbleEmail_item$ref;
    readonly " $refType": PdpRespIconBubbles_item$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpRespIconBubbles_item",
    "type": "Item",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "PdpSharedIconBubblePinterest_item",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "PdpSharedIconBubbleFacebook_item",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "PdpSharedIconBubbleEmail_item",
            "args": null
        }
    ]
} as any);
(node as any).hash = '728b75da82490d73bad044aac0e7039d';
export default node;
